export default function TermsPage() {
  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-12 py-16" data-testid="terms-page">
      <h1 className="font-serif text-4xl font-medium text-nexa-charcoal mb-8">Terms and Conditions</h1>
      <p className="text-muted-foreground mb-8">Last Updated: January 1, 2026</p>
      <div className="prose prose-lg max-w-none text-nexa-charcoal space-y-8">
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
          <p className="text-muted-foreground leading-relaxed">By accessing and using the Nexaorbits website (nexaorbits.store), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you may not access the website or make purchases from us.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">2. Use of Website</h2>
          <p className="text-muted-foreground leading-relaxed mb-4">You agree to use this website only for lawful purposes. Prohibited behavior includes:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>Harassing or causing distress to any person</li>
            <li>Transmitting obscene or offensive content</li>
            <li>Disrupting the normal flow of dialogue on the website</li>
            <li>Attempting to gain unauthorized access to any systems</li>
          </ul>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">3. Products and Pricing</h2>
          <p className="text-muted-foreground leading-relaxed">All products displayed on our website are subject to availability. We reserve the right to discontinue any product at any time. Prices are displayed in US Dollars and are subject to change without notice.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">4. Orders and Payment</h2>
          <p className="text-muted-foreground leading-relaxed">By placing an order, you are making an offer to purchase products. All orders are subject to acceptance and availability. We accept Cash on Delivery and major credit/debit cards.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">5. Shipping</h2>
          <p className="text-muted-foreground leading-relaxed">We ship to addresses within the United States. Orders over $75 qualify for free standard shipping. Please refer to our Shipping Policy for detailed information.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">6. Returns and Refunds</h2>
          <p className="text-muted-foreground leading-relaxed">We offer a 30-day return policy for most items. Products must be returned in their original condition with all tags attached. Please refer to our Refund and Return Policy for complete details.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">7. Intellectual Property</h2>
          <p className="text-muted-foreground leading-relaxed">All content on this website, including text, graphics, logos, images, and software, is the property of Nexaorbits and is protected by copyright and intellectual property laws.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">8. Contact Information</h2>
          <p className="text-muted-foreground leading-relaxed"><strong>Nexaorbits</strong><br />712 Greenfield Avenue, Detroit, MI 11201<br />Email: support@nexaorbits.store<br />Phone: +1-888-351-1122</p>
        </section>
      </div>
    </div>
  );
}
